<template>
  <div class="personnel-record-pane">
    <!-- Compact Header with Record Selection -->
    <v-toolbar
      v-if="!selectedRecordId && !personnelRecord"
      class="pane-header"
      dense
      flat
    >
      <v-icon small class="mr-2">mdi-account</v-icon>
      <span class="text-subtitle-2 font-weight-medium mr-2"
        >Personalakte auswählen:</span
      >
      <person-switcher-selector-menu
        v-model="currentSelection"
        :items="records"
        :enableNavigation="false"
        @record-selected="handleRecordSelected"
      >
      </person-switcher-selector-menu>
    </v-toolbar>

    <!-- Content Area with PersonnelRecordDetails -->
    <div class="pane-content">
      <personnel-record-details
        v-if="selectedRecordId && personnelRecord"
        :propPersonnelRecord="personnelRecord"
        :propPersonnelRecords="records"
        :propOrganizationId="organizationId"
        :propSelectedRecordId="selectedRecordId"
        :propContainerWidth="containerWidth"
        :hideNavigation="true"
        @selection-changed="handleRecordSelection"
      />

      <!-- Empty State -->
      <div v-else class="empty-state">
        <v-icon size="80" color="grey lighten-2">mdi-account-search</v-icon>
        <p class="grey--text text-h6 mt-4 mb-0">Personalakte auswählen</p>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebase";
import {
  getPersonnelRecordId,
  getPersonnelRecordDisplayName,
} from "@/util/personnel-record-utils.js";
import PersonSwitcherSelectorMenu from "@/components/_system/helpers/PersonSwitcherSelectorMenu.vue";
import PersonnelRecordDetails from "@/views/member-management/personnel-records/PersonnelRecordDetails.vue";

export default {
  name: "personnel-record-pane",
  components: {
    PersonSwitcherSelectorMenu,
    PersonnelRecordDetails,
  },
  props: {
    records: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectedRecordId: {
      type: String,
      default: null,
    },
    organizationId: {
      type: String,
      required: true,
    },
    panePosition: {
      type: String,
      required: true, // 'primary' or 'secondary'
    },
    containerWidth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      personnelRecord: null,
      dataIsLoading: false,
    };
  },
  computed: {
    currentSelection: {
      get() {
        return this.selectedRecordId;
      },
      set(value) {
        this.handleRecordSelection(value);
      },
    },
  },
  watch: {
    selectedRecordId: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.loadPersonnelRecord(newId);
        } else {
          this.personnelRecord = null;
        }
      },
    },
  },
  methods: {
    getRecordDisplayName(item) {
      return getPersonnelRecordDisplayName(item);
    },
    getRecordId(item) {
      return getPersonnelRecordId(item);
    },
    handleRecordSelection(recordId) {
      this.$emit("update", recordId);
    },
    handleRecordSelected(record) {
      // Handle when a full record object is selected
      this.$emit("update", record.user.membershipId);
    },
    loadPersonnelRecord(recordId) {
      this.dataIsLoading = true;
      db.collection("organizations")
        .doc(this.organizationId)
        .collection("personnelRecords_general")
        .doc(recordId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.personnelRecord = doc.data();
            this.dataIsLoading = false;
          } else {
            console.log("No such document!");
            this.personnelRecord = null;
            this.dataIsLoading = false;
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
          this.personnelRecord = null;
          this.dataIsLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.personnel-record-pane {
  height: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.theme--dark .personnel-record-pane {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.pane-header {
  max-height: 48px !important;
  height: 48px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
}

.theme--dark .pane-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.pane-content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.empty-state {
  height: 75vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
}
</style>
